module.exports = __webpack_public_path__ + "img/bg-black-big.c3aa4252.jpg";